import {BUSCAR_DISPONIBILIDADES_VEICULO, LIMPAR_DISPONIBILIDADES_VEICULO } from '../../actions/types'

const initialState = undefined;

export default function reducerDisponibilidadesVeiculo (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_DISPONIBILIDADES_VEICULO: {
      const disponibilidadeVeiculo = action.payload.data;

      if (disponibilidadeVeiculo) {
        return disponibilidadeVeiculo
      }
      return []
    }

    case LIMPAR_DISPONIBILIDADES_VEICULO:
      return [];

    default: {
      return state
    }
  }
}
